import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeNotification } from "../reducers/notificationsSlice";
import styles from  "../styles/components/Notifications.module.css";

const NotificationSystem = () => {
  const notifications = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  const handleClose = (id) => {
    dispatch(removeNotification(id));
  };

  return (
    <div className={styles.notificationContainer}>
      {notifications.map((note) => (
        <div key={note.id} className={styles.notificationItem}>
          <p>
            {note.message}
          </p>
          <button className={styles.notificationClose} onClick={() => handleClose(note.id)}>
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationSystem;
